import React, { useState } from "react";
import LookupModal from "./LookupModal";

/**
 * Text input with a search icon that opens a `LookupModal`.
 * - `editable` lets the user type a value manually; otherwise the value only comes from the modal.
 * - `onSelect(record)` fires with the raw record picked in the modal.
 * - `onChange(e)` fires for manual typing (editable only).
 */
export default function LookupField({
  id,
  name,
  value,
  config,
  onSelect,
  onChange,
  editable = false,
  disabled = false,
  required = false,
  isInvalid = false,
  error = "",
  placeholder,
  modalTitle,
  maxLength,
  size,
}) {
  const [open, setOpen] = useState(false);
  const displayValue = value ?? "";
  const title = modalTitle ?? config?.title ?? "Select";

  const openModal = () => {
    if (!disabled) setOpen(true);
  };

  return (
    <>
      <div className={`input-group${size === "sm" ? " input-group-sm" : ""}`}>
        <input
          id={id ?? name}
          name={name}
          type="text"
          className={`form-control ${isInvalid || error ? "is-invalid" : ""}`}
          value={displayValue}
          placeholder={disabled ? "" : placeholder ?? (editable ? "" : "Search")}
          readOnly={!editable}
          disabled={disabled}
          required={required}
          maxLength={maxLength}
          onChange={editable ? onChange : undefined}
          onClick={editable ? undefined : openModal}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              openModal();
            }
          }}
          style={!editable && !disabled ? { cursor: "pointer", backgroundColor: "#fff" } : undefined}
        />
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={openModal}
          disabled={disabled}
          title={title}
        >
          <i className="bi bi-search"></i>
        </button>
      </div>
      {error && <div className="invalid-feedback d-block">{error}</div>}

      <LookupModal
        show={open}
        onHide={() => setOpen(false)}
        selectedId={displayValue}
        title={title}
        config={config}
        onSelect={onSelect}
      />
    </>
  );
}
